export const urlToBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url);

  if (!response.ok) throw new Error("Failed to fetch image");
  // Ensure to await the blob conversion only once.
  const blob = await response.blob();

  return blob;
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;

      const mimeType = blob.type; // Get the MIME type from the blob
      const dataUrl = `data:${mimeType};base64,${base64String.split(",")[1]}`; // Include the MIME type
      resolve(dataUrl);
    };
    reader.onerror = () => {
      reject(new Error("Failed to convert Blob to Base64"));
    };
    reader.readAsDataURL(blob);
  });
};
